// src/services/reminder.service.js
import axiosToken from "../api/axiosClient";

class ReminderService {
  constructor() {
    this.baseURL = "/reports/reminders"; // Base URL de vos routes
  }

  // Génération des rappels
  generateReminders(days) {
    return axiosToken.post(`${this.baseURL}/generate/${days}`);
  }

  // Récupération des rappels avec filtre optionnel
  getReminders(days, status = null) {
    const params = status ? { status } : {};
    return axiosToken.get(`${this.baseURL}/list/${days}`, { params });
  }

  // Envoi des rappels
  sendReminders(days) {
    return axiosToken.post(`${this.baseURL}/send/${days}`);
  }

  // Envoi des SMS
  // sendSmsReminders(days) {
  //   return axiosToken.post(`${this.baseURL}/sms/send/${days}`);
  // }

  // Statut SMS
  // getSmsStatus(messageSid) {
  //   return axiosToken.get(`${this.baseURL}/sms/status/${messageSid}`);
  // }

  // Statistiques SMS
  // getSmsStatistics() {
  //   return axiosToken.get(`${this.baseURL}/sms/statistics`);
  // }

  // Résumé des rappels
  getSummary() {
    return axiosToken.get(`${this.baseURL}/summary`);
  }
}

export default new ReminderService();
